import { render, staticRenderFns } from "./BatchProcessor.vue?vue&type=template&id=7caffe32&scoped=true"
import script from "./BatchProcessor.vue?vue&type=script&lang=js"
export * from "./BatchProcessor.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=7caffe32&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caffe32",
  null
  
)

export default component.exports